import useModels from '../../../Hooks/useModels';
import ToggleSwitch from '../../Utility/ToggleSwitch';
import { ModelsTabName } from '../../../Types/Enums';
import EmbeddingModels from './components/EmbeddingModels';
import ChatModels from './components/ChatModels';
import AdminContainer from '../../Utility/AdminContainer';
import { RootState, useAppSelector } from '../../../store';
import Select from '../../Utility/FormElements/Select';
import VoiceModels from './components/VoiceModels';
import { getBreakpoint } from '../../../utils/breakpoint';

function Models() {
    const settings = useAppSelector((state: RootState) => state.settings);
    const windowWidth = useAppSelector((state: RootState) => state.environment.windowWidth);
    const { userSettings, i18n, currentTab, setCurrentTab } = useModels();

    return userSettings.isSuperAdmin || settings.demo ? (
        <div className={`admin-container flex relative flex-col`}>
            <AdminContainer>
                <div className="mb-5 w-full">
                    {windowWidth > getBreakpoint('md') ? (
                        <ToggleSwitch
                            options={[
                                {
                                    label: i18n.translate({ id: 'chatModels', sourceName: 'Models' }),
                                    function: () => setCurrentTab(ModelsTabName.chatModels),
                                    active: currentTab === ModelsTabName.chatModels,
                                },
                                {
                                    label: i18n.translate({ id: 'embeddingModels', sourceName: 'Models' }),
                                    function: () => setCurrentTab(ModelsTabName.embeddingModels),
                                    active: currentTab === ModelsTabName.embeddingModels,
                                },
                                {
                                    label: i18n.translate({ id: 'voiceModels', sourceName: 'Models' }),
                                    function: () => setCurrentTab(ModelsTabName.voiceModels),
                                    active: currentTab === ModelsTabName.voiceModels,
                                },
                            ]}
                        />
                    ) : (
                        <Select
                            value={currentTab}
                            onChange={(tab) => {
                                setCurrentTab(tab as ModelsTabName);
                            }}
                        >
                            <option value={ModelsTabName.chatModels}>
                                {i18n.translate({ id: 'chatModels', sourceName: 'Models' })}
                            </option>
                            <option value={ModelsTabName.embeddingModels}>
                                {i18n.translate({ id: 'embeddingModels', sourceName: 'Models' })}
                            </option>
                            <option value={ModelsTabName.voiceModels}>
                                {i18n.translate({ id: 'voiceModels', sourceName: 'Models' })}
                            </option>
                        </Select>
                    )}
                </div>
                <div className="box">
                    {currentTab === ModelsTabName.chatModels && <ChatModels />}
                    {currentTab === ModelsTabName.embeddingModels && <EmbeddingModels />}
                    {currentTab === ModelsTabName.voiceModels && <VoiceModels />}
                </div>
            </AdminContainer>
        </div>
    ) : (
        <></>
    );
}

export default Models;
